import apiClient from "../../axios/apiClient";
import { CLAIM_TYPE_CATEGORY } from "../../constants/claimTypeCategory";
import { resolveCaseClaimCategory } from "../../util/caseCategoryNavigation";

// Helper function to extract serializable error data
const getSerializableError = (error) => {
  if (!error) {
    return { message: "An unknown error occurred" };
  }

  if (error.response) {
    // Extract only serializable data from axios error response
    return {
      status: error.response.status,
      statusText: error.response.statusText,
      data: error.response.data,
      // Don't include headers, config, or request as they contain non-serializable objects
    };
  }

  if (error.message) {
    return { message: error.message };
  }

  return { message: "An unknown error occurred" };
};

export const getCaseDetailsList =
  (url, token, limit = 10, page = 1, search = "", sort = "desc", filters) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CASE_DETAILS_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/admin/v1/${url}`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              filters: filters,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CASE_DETAILS_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
          menuData: response.data?.menuData,
          caseStatusCount: response.data?.caseStatusCount,
        });
      }
      catch (error) {
        dispatch({
          type: "GET_CASE_DETAILS_LIST_REJECTED",
          payload: getSerializableError(error),
        });
      }
    };


export const getPendingCaseDetailsList =
  (token, limit = 10, page = 1, search = "", sort = "desc", filters) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_PENDING_CASE_DETAILS_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/admin/v1/Pending-Document`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              filters: filters,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_PENDING_CASE_DETAILS_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
          menuData: response.data?.menuData,
        });
      }
      catch (error) {
        dispatch({
          type: "GET_PENDING_CASE_DETAILS_LIST_REJECTED",
          payload: getSerializableError(error),
        });
      }
    };

export const saveCaseInitiatedData = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_CASE_INITIATED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Initiated`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CASE_INITIATED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_CASE_INITIATED_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveInternalTriggerData = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_INTERNAL_TRIGGER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Internal-Trigger`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_INTERNAL_TRIGGER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_INTERNAL_TRIGGER_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveCaseGeneratedData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_CASE_GENERATED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Generated/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CASE_GENERATED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_CASE_GENERATED_REJECTED", payload: getSerializableError(error) });
  }
};


export const updateCaseDetailsData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CASE_DETAILS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Case-Details/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CASE_DETAILS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_CASE_DETAILS_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveAssignFieldOfficer = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_ASSIGN_FIELD_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Assign-Field-Officer/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_ASSIGN_FIELD_OFFICER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_ASSIGN_FIELD_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};

export const revokeAssignFieldOfficer = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "REVOKE_ASSIGN_FIELD_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Revoke-Field-Officer`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "REVOKE_ASSIGN_FIELD_OFFICER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "REVOKE_ASSIGN_FIELD_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveAssignBackendOfficer = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_ASSIGN_BACKEND_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Generate-Case-Report`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_ASSIGN_BACKEND_OFFICER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_ASSIGN_BACKEND_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveCaseDocuments = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_CASE_DOCUMENTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Save-Case-Documents`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_CASE_DOCUMENTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_CASE_DOCUMENTS_REJECTED", payload: getSerializableError(error) });
  }
};

export const deleteCaseDocument = (token, case_id, document_id, type) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_CASE_DOCUMENT_PENDING" });
    console.log('token, case_id, document_id', token, case_id, document_id);
    const response = await apiClient.delete(
      `/api/admin/V1/Delete-Case-Documents`,
      {
        params: { case_id, document_id, type },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "DELETE_CASE_DOCUMENT_FULFILLED", payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: "DELETE_CASE_DOCUMENT_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveInitialReportDocuments = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_INITIAL_REPORT_DOCUMENTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Initial-Report-Documents`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_INITIAL_REPORT_DOCUMENTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_INITIAL_REPORT_DOCUMENTS_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveQCStatusReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_QC_STATUS_REPORTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/QCstatus-Reports`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_QC_STATUS_REPORTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_QC_STATUS_REPORTS_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveFieldQCStatusReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_FIELD_QC_STATUS_REPORTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Field-QCstatus-Reports`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_FIELD_QC_STATUS_REPORTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_FIELD_QC_STATUS_REPORTS_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveIsClosedReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_IS_CLOSED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Final-Case-Status`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_IS_CLOSED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_IS_CLOSED_REJECTED", payload: getSerializableError(error) });
  }
};

export const updateCaseStatus = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_CASE_STATUS_PENDING" });

    const response = await apiClient.put(
      `/api/admin/v1/Update-Case-Status`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CASE_STATUS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_CASE_STATUS_REJECTED", payload: getSerializableError(error) });
  }
};

export const saveCaseRating = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_CASE_RATING_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Case-Rating`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CASE_RATING_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_CASE_RATING_REJECTED", payload: getSerializableError(error) });
  }
};

export const getCaseDetailsListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CASE_DETAILS_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Case-Details/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_CASE_DETAILS_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_CASE_DETAILS_LISTBYID_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };


export const getCaseLogsListById = (token, id, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CASE_LOGS_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Case-Logs/${id}`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            id: id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_CASE_LOGS_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_CASE_LOGS_LISTBYID_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };


export const updatePendingDocument = (token, id, status, reject_remark) => async (dispatch) => {
  try {
    console.log('token, data', token);
    dispatch({ type: "UPDATE_PENDING_DOCUMENT_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Document-Status/${id}`,
      {
        status: status,
        reject_remark: reject_remark
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_PENDING_DOCUMENT_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_PENDING_DOCUMENT_REJECTED", payload: getSerializableError(error) });
  }
};

export const getDynamicReportById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DYNAMIC_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Get-Dynamic-Report/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DYNAMIC_REPORT_FULFILLED",
        payload: response.data,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_DYNAMIC_REPORT_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };

export const saveDynamicReportData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "SAVE_DYNAMIC_REPORT_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Save-Dynamic-Report/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "SAVE_DYNAMIC_REPORT_FULFILLED", payload: response.data });
  } catch (error) {
    console.log(error.response?.data);
    dispatch({ type: "SAVE_DYNAMIC_REPORT_REJECTED", payload: getSerializableError(error) });
  }
};

// ==================== Motor Case Actions ====================

export const getMotorCaseDetailsList =
  (url, token, limit = 10, page = 1, search = "", sort = "desc", filters) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MOTOR_CASE_DETAILS_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/admin/v1/${url}`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              filters: filters,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MOTOR_CASE_DETAILS_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
          menuData: response.data?.menuData,
          caseStatusCount: response.data?.caseStatusCount,
        });
      }
      catch (error) {
        dispatch({
          type: "GET_MOTOR_CASE_DETAILS_LIST_REJECTED",
          payload: getSerializableError(error),
        });
      }
    };



export const getMotorPendingCaseDetailsList =
  (token, limit = 10, page = 1, search = "", sort = "desc", filters) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MOTOR_PENDING_CASE_DETAILS_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/admin/v1/Pending-Document-Motor`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              filters: filters,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MOTOR_PENDING_CASE_DETAILS_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
          menuData: response.data?.menuData,
        });
      }
      catch (error) {
        dispatch({
          type: "GET_MOTOR_PENDING_CASE_DETAILS_LIST_REJECTED",
          payload: getSerializableError(error),
        });
      }
    };


export const saveMotorCaseInitiatedData = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_CASE_INITIATED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Initiated-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_CASE_INITIATED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_CASE_INITIATED_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorInternalTriggerData = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_INTERNAL_TRIGGER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Internal-Trigger-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_INTERNAL_TRIGGER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_INTERNAL_TRIGGER_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorCaseGeneratedData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_CASE_GENERATED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Generated-Motor/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_CASE_GENERATED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_CASE_GENERATED_REJECTED", payload: getSerializableError(error) });
  }
};



export const updateMotorCaseDetailsData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_MOTOR_CASE_DETAILS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Case-Details-Motor/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_MOTOR_CASE_DETAILS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_MOTOR_CASE_DETAILS_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorAssignFieldOfficer = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_ASSIGN_FIELD_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Assign-Field-Officer-Motor/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_ASSIGN_FIELD_OFFICER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_ASSIGN_FIELD_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};


export const revokeMotorAssignFieldOfficer = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Revoke-Field-Officer-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "REVOKE_MOTOR_ASSIGN_FIELD_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorAssignBackendOfficer = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Generate-Case-Report-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_ASSIGN_BACKEND_OFFICER_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorCaseDocuments = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_CASE_DOCUMENTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Save-Case-Documents-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_CASE_DOCUMENTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_CASE_DOCUMENTS_REJECTED", payload: getSerializableError(error) });
  }
};


export const deleteMotorCaseDocument = (token, case_id, document_id, type) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_MOTOR_CASE_DOCUMENT_PENDING" });
    console.log('token, case_id, document_id', token, case_id, document_id);
    const response = await apiClient.delete(
      `/api/admin/V1/Delete-Case-Documents-Motor`,
      {
        params: { case_id, document_id, type },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "DELETE_MOTOR_CASE_DOCUMENT_FULFILLED", payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: "DELETE_MOTOR_CASE_DOCUMENT_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorInitialReportDocuments = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Initial-Report-Documents-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_INITIAL_REPORT_DOCUMENTS_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorQCStatusReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_QC_STATUS_REPORTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/QCstatus-Reports-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_QC_STATUS_REPORTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_QC_STATUS_REPORTS_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorFieldQCStatusReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Field-QCstatus-Reports-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_FIELD_QC_STATUS_REPORTS_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorIsClosedReports = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_IS_CLOSED_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Final-Case-Status-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_IS_CLOSED_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_IS_CLOSED_REJECTED", payload: getSerializableError(error) });
  }
};


export const updateMotorCaseStatus = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_MOTOR_CASE_STATUS_PENDING" });

    const response = await apiClient.put(
      `/api/admin/v1/Update-Case-Status-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_MOTOR_CASE_STATUS_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_MOTOR_CASE_STATUS_REJECTED", payload: getSerializableError(error) });
  }
};


export const saveMotorCaseRating = (token, data) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "ADD_MOTOR_CASE_RATING_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Case-Rating-Motor`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_MOTOR_CASE_RATING_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "ADD_MOTOR_CASE_RATING_REJECTED", payload: getSerializableError(error) });
  }
};


export const getMotorCaseDetailsListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MOTOR_CASE_DETAILS_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Case-Details-Motor/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MOTOR_CASE_DETAILS_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_MOTOR_CASE_DETAILS_LISTBYID_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };



/** Health → Case-Details/:id; Motor → Case-Details-Motor/:id (by route / env category). */
export const fetchCaseDetailsById = (token, id, pathname = "") => (dispatch) => {
  const category = resolveCaseClaimCategory(pathname);
  if (category === CLAIM_TYPE_CATEGORY.MOTOR) {
    return dispatch(getMotorCaseDetailsListById(token, id));
  }
  return dispatch(getCaseDetailsListById(token, id));
};



export const getMotorCaseLogsListById = (token, id, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MOTOR_CASE_LOGS_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Case-Logs-Motor/${id}`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            id: id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MOTOR_CASE_LOGS_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_MOTOR_CASE_LOGS_LISTBYID_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };



export const updateMotorPendingDocument = (token, id, status, reject_remark) => async (dispatch) => {
  try {
    console.log('token, data', token);
    dispatch({ type: "UPDATE_MOTOR_PENDING_DOCUMENT_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Document-Status-Motor/${id}`,
      {
        status: status,
        reject_remark: reject_remark
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_MOTOR_PENDING_DOCUMENT_FULFILLED", payload: response.data });
  }
  catch (error) {
    dispatch({ type: "UPDATE_MOTOR_PENDING_DOCUMENT_REJECTED", payload: getSerializableError(error) });
  }
};


export const getMotorDynamicReportById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MOTOR_DYNAMIC_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Get-Dynamic-Report-Motor/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MOTOR_DYNAMIC_REPORT_FULFILLED",
        payload: response.data,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_MOTOR_DYNAMIC_REPORT_REJECTED",
        payload: getSerializableError(error),
      });
    }
  };


export const saveMotorDynamicReportData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "SAVE_MOTOR_DYNAMIC_REPORT_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Save-Dynamic-Report-Motor/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "SAVE_MOTOR_DYNAMIC_REPORT_FULFILLED", payload: response.data });
  } catch (error) {
    console.log(error.response?.data);
    dispatch({ type: "SAVE_MOTOR_DYNAMIC_REPORT_REJECTED", payload: getSerializableError(error) });
  }
};